import React from 'react';
import {renderNodeRule, StructuredText as DatoStructuredText} from "react-datocms";
import {isBlockquote, isHeading, isParagraph} from "datocms-structured-text-utils";
import dynamic from "next/dynamic";

const Block     = dynamic(() => import('./Block'),     {
	loading: () => null,
	ssr: false
});

const Heading     = dynamic(() => import('./Heading'),     {
	loading: () => null,
	ssr: false
});

const Paragraph     = dynamic(() => import('./Paragraph'),     {
	loading: () => null,
	ssr: false
});

const Quote   = dynamic(() => import('./Quote'),   {
	loading: () => null,
	ssr: false
});



const StructuredText = ({ data,color='white' }) => {
	return (
		<DatoStructuredText
			data={data}
			renderBlock={({record}) => <Block data={record} color={color}/>}
			customNodeRules={[
				renderNodeRule(isHeading, ({node, children}) => <Heading node={node} color={color}>{children}</Heading>),
				renderNodeRule(isParagraph, ({node, children}) => <Paragraph color={color}>{children}</Paragraph>),
				renderNodeRule(isBlockquote, ({node, children}) => <Quote node={node} color={color}>{children}</Quote>),
			]}
		/>
	);
};

export default StructuredText;
